import React from 'react';

const AboutHero = () => {
  return (
    <section className="relative min-h-[50vh] flex items-center overflow-hidden pt-32 pb-20" style={{ background: '#F8FAFC' }}>
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px]" style={{ background: 'radial-gradient(circle, rgba(38,147,255,0.06) 0%, transparent 70%)' }} />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl">
          <p className="text-sm font-semibold uppercase tracking-widest mb-4 font-heading" style={{ color: '#2693FF' }}>
            About Us
          </p>
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-slate-900 font-heading mb-8 leading-tight">
            We are Clik Technologies.{' '}
            <span className="block mt-2">
              A digital{' '}
              <span style={{ color: '#2693FF' }}>design</span>{' '}
              and{' '}
              <span style={{ color: '#2693FF' }}>development</span>{' '}
              company
            </span>
          </h1>
          <p className="text-lg sm:text-xl text-slate-500 leading-relaxed max-w-3xl">
            We help our clients build their brand identity, and design, develop, launch, and support their digital products. Working with startups and enterprises from all over the world.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutHero;
